import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { MapPin } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PinForm } from "@/components/PinForm";
import { EntryShell } from "@/pages/Entry";

export default function NfcEntry() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user, enterCave } = useAuth();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(false);
  const target = `/locations/${id}`;

  useEffect(() => {
    api.get(`/nfc/${id}`).then((r) => setInfo(r.data)).catch(() => setError(true));
  }, [id]);

  useEffect(() => {
    if (!info || user === null) return;
    if (user && user.cave_id === info.cave_id) {
      navigate(target, { replace: true });
    } else if (user && user.role === "owner") {
      enterCave(info.cave_id).then(() => navigate(target, { replace: true }));
    }
  }, [info, user, enterCave, navigate, target]);

  return (
    <EntryShell>
      {error && <p className="text-[#E5A93C]" data-testid="nfc-error">This NFC tag points to a location that no longer exists.</p>}
      {info && (
        <>
          <div className="flex items-center gap-3 mb-8 rounded-lg border border-[#2E252A] bg-[#161214] px-4 py-3" data-testid="nfc-location-info">
            <MapPin className="w-5 h-5 text-[#D4AF37]" strokeWidth={1.5} />
            <div>
              <p className="text-[#F5F0EB]">{info.location_name}</p>
              <p className="text-xs text-[#6E665D]">{info.cave_name}</p>
            </div>
          </div>
          {!(user && user.role === "owner") && <PinForm caveId={info.cave_id} onDone={() => navigate(target, { replace: true })} />}
        </>
      )}
    </EntryShell>
  );
}
